// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KpPL","content":"styles_content__bcRRl","tableWrap":"styles_tableWrap__YcyC_"};